export const DeanLink = [
    {
        urlLink: '/',
        nameLink: 'Trang chủ',
    },
    {
        urlLink: '/danhsachdetai',
        nameLink: 'Danh sách đề tài',
    },
    {
        urlLink: '/thongtingiangvien',
        nameLink: 'Thông tin giảng viên',
    },
    {
        urlLink: '/thongtinsinhvien',
        nameLink: 'Thông tin sinh viên',
    },
    {
        urlLink: '/pheduyet',
        nameLink: 'Hàng đợi phê duyệt',
    },
    {
        urlLink: '/themdulieu',
        nameLink: 'Thêm mới dữ liệu',
    },
    {
        urlLink: '/thongke',
        nameLink: 'Thống kê',
    },
];

export const StudentLink = [
    {
        urlLink: '/',
        nameLink: 'Trang chủ',
    },
    {
        urlLink: '/quanlitaikhoan',
        nameLink: 'Quản lý tài khoản',
    },
    {
        urlLink: '/quanlynhom',
        nameLink: 'Quản lý nhóm',
    },
    {
        urlLink: '/',
        nameLink: 'Hướng dẫn đăng ký',
    },
    {
        urlLink: '/dangkidetai',
        nameLink: 'Đăng ký đề tài',
    },
    {
        urlLink: '/trangthaidetai',
        nameLink: 'Trạng thái đề tài',
    },
];

export const LecturersLink = [
    {
        urlLink: '/',
        nameLink: 'Trang chủ',
    },
    {
        urlLink: '/pheduyet',
        nameLink: 'Danh sách đề tài',
    },
    {
        urlLink: '/thongtinnhom',
        nameLink: 'Thông tin nhóm đăng ký',
    },
];